module.exports = __webpack_public_path__ + "img/guangai.ed97247c.png";